<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="정산 완료 조회"
      desc="정산 완료로 들어온 내역을 조회할 수 있습니다."
    ></admin-filter>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="partner_name" slot-scope="props">
        {{ props.item.partner_name }}
      </td>

      <td slot="acc_date" slot-scope="props">{{ props.item.acc_date }}</td>

      <td slot="total_price" slot-scope="props">
        {{ props.item.total_price | currency }}
      </td>

      <td slot="comm_price" slot-scope="props">
        {{ props.item.comm_price | currency }}
      </td>

      <td slot="coupon_price" slot-scope="props">
        {{ props.item.coupon_price | currency }}
      </td>

      <td slot="delivery_cost" slot-scope="props">
        {{ props.item.delivery_cost | currency }}
      </td>

      <td slot="point" slot-scope="props">
        {{ props.item.point | currency }}
      </td>

      <td slot="acc_price" slot-scope="props">
        {{ props.item.acc_price | currency }}
      </td>

      <td slot="history" slot-scope="props">
        <button class="button" @click="openHistory(props.item.id)">내역보기</button>
      </td>

    </order-table>

    <modal name="historyModal"
           :adaptive="true"
           :width="900"
           :height="600"
           style="overflow-y: scroll"
           class="modal-style">
      <div class="lp-modal-wrapper" v-if="detail">
        <div class="btn-group-justify-end" style="padding:0 12px">
          <i class="material-icons modal-exit" @click="$modal.hide('historyModal')">close</i>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th>주문번호</th>
            <th>주문자</th>
            <th>상품명</th>
            <th>주문금액</th>
            <th>구매일</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order_prod,idx) in detail.order_product" :key="'history-'+idx">
            <td>{{ order_prod.order_num }}</td>
            <td>{{ order_prod.order_name }}</td>
            <!-- 주문 상품 -->
            <td>
              <div class="flex align-center">
                <img :src="order_prod.product_img" style="width:35px;height:35px;margin-right:6px" v-if="order_prod.product_img">
                <div style="text-align: left">
                  <div v-if="order_prod.order_product_option.length>0">
                    <div>{{ order_prod.product_name }}</div>
                    <div
                      v-for="(option, option_idx) in order_prod.order_product_option"
                      :key="'option-'+option_idx">
                      <span v-if="option.option.option_type===0">기본옵션:</span>
                      <span v-if="option.option.option_type===1">추가옵션:</span>
                      {{ optionFullName(option) }}
                    </div>
                  </div>
                  <div v-else>
                    {{ order_prod.product_name }} {{ order_prod.quantity }}개
                  </div>
                </div>
              </div>
            </td>
            <td>{{ order_prod.total_price | currency }}</td>
            <td>{{ convertDate(order_prod.created_time, 'datetime') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </modal>
  </div>
</template>

<script>
  import MartMixin from '@/mixins/MartMixin'
  export default {
    name: 'AccountAll',
    components: {},
    mixins: [
      MartMixin
    ],
    data() {
      return {
        detail: undefined
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // 정산 처리 안되어있는 경우 isnull=true
        this.initializing('account_all', 'mart/account');
        //this.filtered.acc_date=false;

        if(!this.isAdmin) {
          for(let i=0; i<this.filterData.length; i++) {
            let item = this.filterData[i];
            if(item.type==='search') {
              removeIndex(this.filterData,i);
            }
          }
        }
      },
      getDataFromServer() {
        this.getData();
      },
      openHistory(id) {
        this.$store.commit('setLoading', true);
        this.$axios.get(this.getUrl(`mart/account/${id}`)).then(res=> {
          this.$store.commit('setLoading', false);
          this.detail = res.data;
          this.$modal.show('historyModal');
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
